var _g, _path, _path2, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashedLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      left: 1,
      top: 1,
      width: 32,
      height: 30,
      display: "block",
      position: "relative",
      overflow: "hidden"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)",
    style: {
      visibility: "visible"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2.12 27.56 L 28.62 1.06",
    fill: "none",
    stroke: "white",
    strokeWidth: 9.3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    visibility: "hidden"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 2.12 27.56 L 28.62 1.06",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeDasharray: "1.59 1.59",
    pointerEvents: "stroke"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashedLine);
export default __webpack_public_path__ + "static/media/dashed-line.40306436f2cefe44d1cfc8a3f6042d76.svg";
export { ForwardRef as ReactComponent };